import React, { useState, Fragment } from "react";
import { useNavigate } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, BarElement, ArcElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar, Line, Pie, Radar } from 'react-chartjs-2';
import 'chart.js/auto';
import { Table, DropdownButton, Dropdown, Button, Form, Card, Alert } from 'react-bootstrap';
import { HeatMapGrid } from 'react-grid-heatmap'

import { Container } from "react-bootstrap";
import { BsToggleOff, BsToggleOn } from "react-icons/bs";
import { MdHeight } from "react-icons/md";
import axios from "axios";
import { API_URL } from '../../../api/constants';

// Register required components with ChartJS
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    ArcElement,
    Title,
    Tooltip,
    Legend
);

const Profile1 = (props) => {
    const [selectedTab, setSelectedTab] = useState(0);
    const navigate = useNavigate();

    const handleTabSelect = (index) => {
        setSelectedTab(index);
    };
    const data = props.data


    const emailFromLocalStorage = localStorage.getItem('email'); // Get the email from local storage

    // Filter the data based on the email
    const filteredData = data.filter((item) => item.email === emailFromLocalStorage);




    const lineData = {
        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
        datasets: [
            {
                label: 'Engagement Rate',
                data: [56, 60, 53, 58, 59, 71, 65],
                fill: false,
                backgroundColor: 'rgba(209, 145, 25,0.4)',
                borderColor: 'rgba(209, 145, 25,1)',
            },
            {
                label: 'Sentiment Score',
                data: [61, 59, 80, 81, 50, 55, 55],
                fill: false,
                backgroundColor: 'rgba(94, 23, 156,0.4)',
                borderColor: 'rgba(94, 23, 156,1)',
            },
            {
                label: 'Growth Rate',
                data: [10, 20, -15, 12, 20, 23, 35],
                fill: false,
                backgroundColor: 'rgba(23, 156, 52,0.4)',
                borderColor: 'rgba(23, 156, 52,1)',
            },
        ],
    };

    const SegmentChangesData = {
        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
        datasets: [
            {
                label: 'Price-Sensitive Shopper',
                data: [220, 234, 200, 250, 280, 250, 270],
                fill: false,
                backgroundColor: 'rgba(204, 69, 2,0.4)',
                borderColor: 'rgba(204, 69, 2,1)',
            },
            {
                label: 'Brand Loyalist',
                data: [102, 106, 115, 180, 210, 150, 140],
                fill: false,
                backgroundColor: 'rgba155, 209, 69,0.4)',
                borderColor: 'rgba(155, 209, 69,1)',
            },
            {
                label: 'Impulse Buyer',
                data: [50, 60, 34, 23, 40, 35, 33],
                fill: false,
                backgroundColor: 'rgba(209, 69, 169,0.4)',
                borderColor: 'rgba(209, 69, 169,1)',
            },
            {
                label: 'Quality Seeker',
                data: [75, 110, 100, 122, 180, 190, 170],
                fill: false,
                backgroundColor: 'rgba(35, 35, 173,0.4)',
                borderColor: 'rgba(35, 35, 173,1)',
            },
            {
                label: 'Socially Conscious Consumer',
                data: [220, 250, 240, 300, 310, 280, 290],
                fill: false,
                backgroundColor: 'rgba(21, 179, 110,0.4)',
                borderColor: 'rgba(21, 179, 110,1)',
            },
            {
                label: 'Tech-Savvy Enthusiast',
                data: [40, 50, 45, 59, 65, 70, 73],
                fill: false,
                backgroundColor: 'rgba(140, 173, 55,0.4)',
                borderColor: 'rgba(140, 173, 55,1)',
            },
        ],
    };

    const lineOptions = {
        scales: {
            y: {
                beginAtZero: true,
            },
        },
    };
    /*
        const pieData = {
            labels: ['Social Media', 'Customer Support', 'CRM', 'E-Commerce', 'Website Analytitcs'],
            datasets: [
                {
                    label: 'Distribution of insight resources',
                    data: [300, 50, 100, 70, 120],
                    backgroundColor: ['#39e6da', '#36A2EB', '#dae639', '#cf5b0e', '#2e3b78', '#82911f'],
                    hoverBackgroundColor: ['#14ffef', '#2baaff', '#eefc30', '#fc6603', '#3856e0', '#b9cf29'],
                },
            ],
        };
    */


    // Count the number of "yes" values for each source
    const crmSourceNumber = filteredData.filter((item) => item.crm_source === "yes").length;
    const socialSourceNumber = filteredData.filter((item) => item.social_source === "yes").length;
    const websiteSourceNumber = filteredData.filter((item) => item.website_source === "yes").length;
    //const ecommerceSourceNumber = filteredData.filter((item) => item.ecommerce_source === "yes").length;
    const customerSupportSourceNumber = filteredData.filter((item) => item.customersupport_source === "yes").length;

    // Calculate the total number of "yes" values across all sources
    const totalSource = crmSourceNumber + socialSourceNumber + websiteSourceNumber + customerSupportSourceNumber;

    // Calculate the percentage share of each source
    const crmShare = (crmSourceNumber / totalSource) * 100;
    const socialShare = (socialSourceNumber / totalSource) * 100;
    const websiteShare = (websiteSourceNumber / totalSource) * 100;
    //const ecommerceShare = (ecommerceSourceNumber / totalSource) * 100;
    const customerSupportShare = (customerSupportSourceNumber / totalSource) * 100;

    // Prepare the data for the pie chart
    const pieData = {
        labels: ['Social Media', 'Customer Support', 'CRM', 'Website Analytics'],
        datasets: [
            {
                label: 'Distribution of insight resources',
                data: [socialShare, customerSupportShare, crmShare, websiteShare],
                backgroundColor: ['#39e6da', '#36A2EB', '#dae639', '#cf5b0e', '#2e3b78'],
                hoverBackgroundColor: ['#14ffef', '#2baaff', '#eefc30', '#fc6603', '#3856e0'],
            },
        ],
    };

    // Now you can use pieData in your pie chart component

    const pieOptions = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
        },
    };

    const barData = {
        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
        datasets: [
            {
                label: 'Revenue',
                data: [65, 59, 80, 81, 56, 55, 40],
                backgroundColor: 'rgba(75,192,192,0.4)',
                borderColor: 'rgba(75,192,192,1)',
                borderWidth: 1,
            },
        ],
    };

    const barOptions = {
        scales: {
            y: {
                beginAtZero: true,
            },
        },
        plugins: {
            legend: {
                display: false, // Hide the legend (if it's showing)
            },
            title: {
                display: false, // Hide the title (if it's showing)
            },
        },
    };



    //////Segments by CRM
    // Calculate the frequency of each segment
    // Filter out items where the segment is null or undefined
    const validData = filteredData.filter(item => item.segment !== null && item.segment !== "null" && item.segment !== undefined);

    // Calculate the frequency of each segment
    const segmentFrequency = validData.reduce((acc, item) => {
        acc[item.segment] = (acc[item.segment] || 0) + 1;
        return acc;
    }, {});

    // Calculate the total number of items
    const totalItems = validData.length;

    // Calculate the percentage of each segment
    const segmentPercentage = Object.keys(segmentFrequency).map((segment) => ({
        segment,
        percentage: (segmentFrequency[segment] / totalItems) * 100,
    }));

    const segmentNumber = Object.keys(segmentFrequency).map((segment) => ({
        segment,
        number: (segmentFrequency[segment]),
    }));

    console.log("validData:", validData);
    console.log("segmentPercentage:", segmentPercentage);

    // Prepare the data for the Segment chart
    const classificationData = {
        labels: segmentNumber.map((item) => item.segment),
        datasets: [
            {
                label: "", // Set label to an empty string
                data: segmentNumber.map((item) => item.number),
                backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF"], // Modern and attractive colors
                hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF"],
            },
        ],
    };

    ////////////
    const segmentDescriptions = {
        "Price-Sensitive Shopper": "Focused on affordability and value for money.",
        "Brand Loyalist": "Prefers sticking with trusted and familiar brands.",
        "Impulse Buyer": "Often makes spontaneous purchase decisions.",
        "Quality Seeker": "Prioritizes high-quality products over price.",
        "Socially Conscious Consumer": "Values ethical and sustainable practices.",
        "Tech-Savvy Enthusiast": "Enthusiastic about the latest technology and gadgets.",
    };

    // Filter valid data and get unique segments
    const uniqueSegments = Array.from(new Set(
        filteredData
            .filter(item => item.segment && item.segment !== null && item.segment !== "null" && typeof item.segment === "string") // Valid segments
            .map(item => item.segment) // Extract segments
    ));





    //////Clusters by CRM
    // Calculate the frequency of each segment
    // Filter out items where the segment is null or undefined
    const validCluster = filteredData.filter(item => item.cluster !== null && item.cluster !== "null" && item.cluster !== undefined);

    // Calculate the frequency of each cluster
    const clusterFrequency = validCluster.reduce((acc, item) => {
        acc[item.cluster] = (acc[item.cluster] || 0) + 1;
        return acc;
    }, {});

    // Calculate the total number of items
    const totalClusterItems = validCluster.length;

    // Calculate the percentage of each cluster
    const clusterPercentage = Object.keys(clusterFrequency).map((cluster) => ({
        cluster,
        percentage: (clusterFrequency[cluster] / totalClusterItems) * 100,
    }));

    const clusterNumber = Object.keys(clusterFrequency).map((cluster) => ({
        cluster,
        number: (clusterFrequency[cluster]),
    }));

    console.log("validCluster:", validCluster);
    console.log("clusterPercentage:", clusterPercentage);

    // Prepare the data for the cluster chart
    const clusterData = {
        labels: clusterNumber.map((item) => item.cluster),
        datasets: [
            {
                label: "", // Set label to an empty string
                data: clusterNumber.map((item) => item.number),
                backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF"], // Modern and attractive colors
                hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF"],
            },
        ],
    };

    ////////////
    const clusterDescriptions = {
        "Value-Oriented Shoppers": "Customers who prefer online shopping, are members of loyalty programs, and tend to make frequent, moderately priced purchases. They respond well to promotional campaigns and have moderate brand affinity.",
        "Affluent Brand Loyalists": "High-income individuals with strong brand affinities and preferences for premium product categories. They make fewer purchases but have a high average purchase value and are less responsive to ads.",
        "Young Social Media Enthusiasts": "Younger customers with high social media activity, strong interests in trending products, and high ad responsiveness. They engage with lower-value but frequent purchases.",
        "Traditional Shoppers": "Older, less tech-savvy individuals who prefer in-store shopping, exhibit low brand affinity, and rarely engage in loyalty programs. They respond minimally to digital ads.",
        "Diverse Budget-Conscious Buyers": "Customers with average income and varied interests, who frequently purchase lower-priced items. They are responsive to loyalty programs and discounts but have moderate online shopping preferences.",
    };

    // Filter valid data and get unique clusters
    const uniqueClusters = Array.from(new Set(
        filteredData
            .filter(item => item.cluster && item.cluster !== null && item.cluster !== "null" && typeof item.cluster === "string") // Valid clusters
            .map(item => item.cluster) // Extract clusters
    ));



    ///////
    //////Segments by Website
    // Calculate the frequency of each segment
    // Filter out items where the segment is null or undefined
    const validWebData = filteredData.filter(item => item.website_segment !== null && item.website_segment !== "null" && item.website_segment !== undefined);

    // Calculate the frequency of each website_segment
    const webSegmentFrequency = validWebData.reduce((acc, item) => {
        acc[item.website_segment] = (acc[item.website_segment] || 0) + 1;
        return acc;
    }, {});

    // Calculate the total number of items
    const totalWebItems = validWebData.length;

    // Calculate the percentage of each segment
    const webSegmentPercentage = Object.keys(webSegmentFrequency).map((website_segment) => ({
        website_segment,
        webPercentage: (webSegmentFrequency[website_segment] / totalItems) * 100,
    }));

    const webSegmentNumber = Object.keys(webSegmentFrequency).map((website_segment) => ({
        website_segment,
        number: (webSegmentFrequency[website_segment]),
    }));

    console.log("validData:", validData);
    console.log("segmentPercentage:", webSegmentPercentage);

    // Prepare the data for the website_segment chart
    const webClassificationData = {
        labels: webSegmentNumber.map((item) => item.website_segment),
        datasets: [
            {
                label: "", // Set label to an empty string
                data: webSegmentNumber.map((item) => item.number),
                backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF"], // Modern and attractive colors
                hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF"],
            },
        ],
    };

    ////////////
    const webSegmentDescriptions = {
        "Buyer": "These users demonstrate clear intent to purchase, with high conversion rates and efficient navigation through the website, making them the most valuable audience segment.",
        "Non-Engaged": "These visitors have short sessions, high bounce rates, and minimal interaction, indicating that the website content or user experience is failing to capture their interest.",
        "Impulse Buyer": "Often makes spontaneous purchase decisions.",
        "Browser": "These users spend considerable time exploring the website and navigating through multiple pages but exhibit low conversion rates, suggesting curiosity or indecision rather than purchase intent.",
    };

    // Filter valid data and get unique segments
    const webUniqueSegments = Array.from(new Set(
        filteredData
            .filter(item => item.website_segment && item.website_segment !== null && item.website_segment !== "null" && typeof item.website_segment === "string") // Valid website_segments
            .map(item => item.website_segment) // Extract website_segments
    ));

    /////////////

    //////Clusters by Website
    // Calculate the frequency of each segment
    // Filter out items where the segment is null or undefined
    const validWebCluster = filteredData.filter(item => item.website_cluster !== null && item.website_cluster !== "null" && item.website_cluster !== undefined);

    // Calculate the frequency of each website_cluster
    const webClusterFrequency = validWebCluster.reduce((acc, item) => {
        acc[item.website_cluster] = (acc[item.website_cluster] || 0) + 1;
        return acc;
    }, {});

    // Calculate the total number of items
    const totalWebClusterItems = validWebCluster.length;

    // Calculate the percentage of each cluster
    const webClusterPercentage = Object.keys(webClusterFrequency).map((website_cluster) => ({
        website_cluster,
        percentage: (webClusterFrequency[website_cluster] / totalWebClusterItems) * 100,
    }));

    const webClusterNumber = Object.keys(webClusterFrequency).map((website_cluster) => ({
        website_cluster,
        number: (webClusterFrequency[website_cluster]),
    }));

    console.log("validWebCluster:", validWebCluster);
    console.log("webClusterPercentage:", webClusterPercentage);

    // Prepare the data for the cluster chart
    const webClusterData = {
        labels: webClusterNumber.map((item) => item.website_cluster),
        datasets: [
            {
                label: "", // Set label to an empty string
                data: webClusterNumber.map((item) => item.number),
                backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF"], // Modern and attractive colors
                hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF"],
            },
        ],
    };

    ////////////
    const webClusterDescriptions = {
        "Engaged Buyers": "Visitors with high time spent on the site, low bounce rates, and high conversion rates. They exhibit long session durations and navigate through multiple pages, indicating strong interest and intent to purchase.",
        "Casual Browsers": "Visitors with moderate time spent and session duration but low conversion rates. Their path length suggests casual exploration of the website without strong purchasing intent.",
        "Bouncers": "Visitors with very short session durations, high bounce rates, and low CTR. These users quickly leave the site, likely due to unmet expectations or lack of interest.",
        "Decisive Shoppers": "Visitors with short sessions and few page visits but a high conversion rate. These users know exactly what they want and complete their purchases efficiently.",
        "Indecisive Explorers": "Visitors with long session durations and high path lengths but low conversion and click-through rates. They spend significant time exploring but struggle to commit to purchases or desired actions.",
    };

    // Filter valid data and get unique clusters
    const uniqueWebClusters = Array.from(new Set(
        filteredData
            .filter(item => item.website_cluster && item.website_cluster !== null && item.website_cluster !== "null" && typeof item.website_cluster === "string") // Valid website_clusters
            .map(item => item.website_cluster) // Extract website_clusters
    ));




    ///////

    const satisfactionData = {
        labels: ['Promoters', 'Neutrals', 'Detractors'],
        datasets: [
            {
                label: 'Satisfaction Levels',
                data: [70, 20, 10],
                backgroundColor: ['#4BC0C0', '#FFCE56', '#FF6384'],
            },
        ],
    };

    const purchaseProbabilityData = {
        labels: ['User A', 'User B', 'User C', 'User D', 'User E'],
        datasets: [
            {
                label: 'Purchase Probability (%)',
                data: [90, 60, 70, 85, 50],
                borderColor: '#36A2EB',
                fill: false,
            },
        ],
    };

    const userTrendData = {
        labels: ['January', 'February', 'March', 'April', 'May', 'June'],
        datasets: [
            {
                label: 'User Trend',
                data: [12, 19, 3, 5, 2, 3],
                borderColor: '#FF6384',
                backgroundColor: 'rgba(255, 99, 132, 0.2)',
            },
        ],
    };

    // Count sentiments for Social Media
    const socialSentimentCounts = filteredData.reduce(
        (acc, item) => {
            if (item.social_sentiment) {
                acc[item.social_sentiment.toLowerCase()] = (acc[item.social_sentiment.toLowerCase()] || 0) + 1;
            }
            return acc;
        },
        { positive: 0, negative: 0, neutral: 0, critical: 0 }
    );

    // Count sentiments for Customer Support
    const cussupSentimentCounts = filteredData.reduce(
        (acc, item) => {
            if (item.cussup_sentiment) {
                acc[item.cussup_sentiment.toLowerCase()] = (acc[item.cussup_sentiment.toLowerCase()] || 0) + 1;
            }
            return acc;
        },
        { positive: 0, negative: 0, neutral: 0, critical: 0 }
    );

    // Prepare the data for the radar chart
    const socialSentimentData = {
        labels: ['Positive', 'Negative', 'Neutral', 'Critical'],
        datasets: [
            {
                label: 'Social Media Sentiments',
                data: [
                    socialSentimentCounts.positive,
                    socialSentimentCounts.negative,
                    socialSentimentCounts.neutral,
                    socialSentimentCounts.critical,
                ],
            },
            {
                label: 'Customer Support Sentiments',
                data: [
                    cussupSentimentCounts.positive,
                    cussupSentimentCounts.negative,
                    cussupSentimentCounts.neutral,
                    cussupSentimentCounts.critical,
                ],
            },
        ],
    };


    const userBehaviorData = {
        labels: ['Category A', 'Category B', 'Category C', 'Category D'],
        datasets: [
            {
                label: 'Behavior Categories',
                data: [40, 50, 75, 100],
                backgroundColor: ['#FFCE56', '#4BC0C0', '#36A2EB', '#FF6384'],
            },
        ],
    };


    // Sample Data for NextContent
    const contentNeedsData = {
        labels: ['Informative', 'Promotional', 'Engagement', 'Support'],
        datasets: [
            {
                label: 'Price-Sensitive Shopper',
                data: [80, 60, 10, 5],
                backgroundColor: 'rgba(120, 26, 163, 0.4)',
            },
            {
                label: 'Brand Loyalist',
                data: [10, 5, 20, 80],
                backgroundColor: 'rgba(120, 26, 163, 0.4)',
            },
            {
                label: 'Impulse Buyer',
                data: [60, 85, 70, 10],
                backgroundColor: 'rgba(13, 75, 145, 0.4)',
            },
            {
                label: 'Quality Seeker',
                data: [94, 20, 10, 76],
                backgroundColor: 'rgba(23, 173, 123, 0.4)',
            },
            {
                label: 'Socially Conscious Consumer',
                data: [45, 12, 70, 64],
                backgroundColor: 'rgba(118, 199, 38, 0.4)',
            },
            {
                label: 'Tech-Savvy Enthusiast',
                data: [90, 5, 67, 74],
                backgroundColor: 'rgba(230, 167, 60, 0.4)',
            },
        ],
    };




    // Sample Data for Crisis Management
    const sentimentData = {
        xLabels: ['Twitter', 'Facebook', 'Instagram', 'News'],
        yLabels: ['Positive', 'Neutral', 'Negative'],
        data: [
            [90, 10, 0, 80],
            [70, 20, 10, 20],
            [50, 30, 20, 45],
        ],
    };

    const sentimentTrendData = {
        labels: ['Week 1', 'Week 2', 'Week 3', 'Week 4'],
        datasets: [
            {
                label: 'Positive Sentiment',
                data: [80, 75, 70, 60],
                borderColor: 'rgba(75, 192, 192, 1)',
                fill: false,
            },
            {
                label: 'Negative Sentiment',
                data: [10, 15, 20, 30],
                borderColor: 'rgba(255, 99, 132, 1)',
                fill: false,
            },
        ],
    };

    const [anomalyAlerts, setAnomalyAlerts] = useState([
        { time: '12:00 PM', channel: 'Twitter', severity: 'High', description: 'Sudden spike in negative mentions' },
        { time: '11:45 AM', channel: 'Facebook', severity: 'Medium', description: 'Increase in neutral comments' },
    ]);

    const impactForecastData = {
        labels: ['Current', '1 Day', '2 Days', '3 Days'],
        datasets: [
            {
                label: 'Brand Reputation',
                data: [80, 70, 60, 50],
                borderColor: 'rgba(153, 102, 255, 1)',
                fill: false,
            },
        ],
    };


    const textAreaStyle = {
        width: '100%',
        height: '100px',
        marginBottom: '1em',
    };

    const rowStyle = {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '1em',
    };

    const columnStyle = {
        width: '48%',
    };

    const buttonStyle = {
        width: '100%',
        padding: '10px',
        margin: '5px 0',
        fontSize: '16px',
        cursor: 'pointer',
    };

    const buttonStyle2 = {
        width: '100%',
        padding: '10px',
        margin: '5px 0',
        fontSize: '16px',
        cursor: 'pointer',
    };

    const rowStyle2 = {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '1em',
    };

    const columnStyle2 = {
        width: '32%', // Adjust width to ensure 3 buttons fit in one row with some spacing
    };


    ////content generation

    const [selectedMedia, setSelectedMedia] = useState("Select Media");
    const [selectedPersona, setSelectedPersona] = useState("Select Audience Persona");
    const [companyName, setCompanyName] = useState("");
    const [productDescription, setProductDescription] = useState("");
    const [subject, setSubject] = useState("");
    const [generatedContent, setGeneratedContent] = useState("");

    const generateContent = async () => {
        const requestBody = {
            media: selectedMedia,
            persona: selectedPersona,
            companyName,
            productDescription,
            subject,
        };

        try {
            const response = await axios.post(`${API_URL}/dashboard-b2c/content`, requestBody);
            setGeneratedContent(response.data.content);
        } catch (error) {
            console.error("Error generating content:", error);
            setGeneratedContent("Error generating content. Please try again.");
        }
    };


    ////personalized content generation

    const [selectedPersonalizedMedia, setSelectedPersonalizedMedia] = useState("Select Media");
    const [selectedPersonalizedPersona, setSelectedPersonalizedPersona] = useState("Select Audience Persona");
    //const [companyName, setCompanyName] = useState("");
    //const [productDescription, setProductDescription] = useState("");
    const [personalizedSubject, setPersonalizedSubject] = useState("");
    const [generatedPersonalizedContent, setPersonalizedGeneratedContent] = useState("");

    const generatePersonalizedContent = async () => {
        const requestBody = {
            media: selectedMedia,
            persona: selectedPersona,
            companyName,
            productDescription,
            personalizedSubject,
        };

        try {
            const response = await axios.post(`${API_URL}/dashboard-b2c/content`, requestBody);
            setPersonalizedGeneratedContent(response.data.content);
        } catch (error) {
            console.error("Error generating personalized content:", error);
            setPersonalizedGeneratedContent("Error generating content. Please try again.");
        }
    };


    const [generatedContents, setGeneratedContents] = useState({});

    const generateContentForItems = async () => {
        const filteredItems = data.filter(
            (item) =>
                (item.cussup_sentiment === "negative" || item.social_sentiment === "negative") &&
                item.email === storedEmail
        );

        const contentPromises = filteredItems.map(async (item) => {
            const requestBody = {
                media: selectedPersonalizedMedia, // Assuming selectedMedia is defined
                persona: [
                    item.segment,
                    item.cluster,
                    item.website_cluster,
                    item.website_segment
                ]
                    .filter(part => part !== null && part !== undefined && part !== "") // Remove null, undefined, or empty values
                    .join(" and "), // Join remaining parts with "and"

                companyName,
                productDescription,
                personalizedSubject: `${personalizedSubject} and Write this message to someone who has had negative feelings about the brand or product in their feedback. The text needs to help them normalize and become more positive about the brand or product.`,
            };


            try {
                //const response = await axios.post(`${API_URL}/dashboard-b2c/content`, requestBody);

                const response = await fetch(`${API_URL}/dashboard-b2c/content`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                });

                const result = await response.json();
                return { id: item.id, content: result.content };
            } catch (error) {
                console.error("Error generating content:", error);
                return { id: item.id, content: "Error generating content" };
            }
        });

        const contents = await Promise.all(contentPromises);

        // Update the state with the generated content for each ID
        const newGeneratedContents = {};
        contents.forEach(({ id, content }) => {
            newGeneratedContents[id] = content;
        });

        setGeneratedContents(newGeneratedContents);
    };

    //crisis management
    // Filter data for critical social sentiments
    const socialCrisisData = data.filter(
        (item) => item.email === emailFromLocalStorage && item.social_sentiment?.toLowerCase() === "critical"
    );

    // Filter data for critical customer support sentiments
    const cussupCrisisData = data.filter(
        (item) => item.email === emailFromLocalStorage && item.cussup_sentiment?.toLowerCase() === "critical"
    );


    //show ids in textbox for CRM cluster:
    const [selectedIDs, setSelectedIDs] = useState([]);

    // Get email from local storage
    const storedEmail = localStorage.getItem("email");

    // Handle button click for CRM Cluster
    const handleClusterClick = (clusterName) => {
        const ids = data
            .filter(item => item.cluster === clusterName && item.email === storedEmail)
            .map(item => item.id);
        setSelectedIDs(ids); // Update the state with filtered IDs
    };

    const [selectedSegmentIDs, setSelectedSegmentIDs] = useState([]);
    const handleSegmentClick = (segmentName) => {
        const ids = data
            .filter(item => item.segment === segmentName && item.email === storedEmail)
            .map(item => item.id);
        setSelectedSegmentIDs(ids); // Update the state with filtered IDs
    };

    const [selectedWebSegmentIDs, setSelectedWebSegmentIDs] = useState([]);
    const handleWebSegmentClick = (segmentName) => {
        const ids = data
            .filter(item => item.website_segment === segmentName && item.email === storedEmail)
            .map(item => item.id);
        setSelectedWebSegmentIDs(ids); // Update the state with filtered IDs
    };

    const [selectedWebClusterIDs, setSelectedWebClusterIDs] = useState([]);
    const handleWebClusterClick = (segmentName) => {
        const ids = data
            .filter(item => item.website_cluster === segmentName && item.email === storedEmail)
            .map(item => item.id);
        setSelectedWebClusterIDs(ids); // Update the state with filtered IDs
    };

    const [selectedNegativeIDs, setSelectedNegativeIDs] = useState([]);
    const handleNegativeClick = () => {
        const ids = data
            .filter(item => (item.cussup_sentiment === "negative" || item.social_sentiment === "negative") && item.email === storedEmail)
            .map(item => item.id);
        setSelectedNegativeIDs(ids); // Update the state with filtered IDs
    };



    return (
        <Fragment>
            <div className="container">
                <div className="tf-section flat-author-profile flat-explore flat-auctions">
                    <div className="row">
                        <div className="col-lg-10 col-md-12">
                            <div className="container">
                                <div className="flat-tabs tab-author">
                                    <Tabs selectedIndex={selectedTab} onSelect={handleTabSelect}>
                                        <div style={{ backgroundColor: "orange", borderRadius: "1em" }}>
                                            <TabList className="menu-tab tab-title">
                                                <Tab>
                                                    <h3
                                                        style={{
                                                            color: "white",
                                                            borderBottom: selectedTab === 0 ? "2px solid white" : "none",
                                                            paddingBottom: '5px'
                                                        }}
                                                    >
                                                        NextInsight
                                                    </h3>
                                                </Tab>
                                                <Tab>
                                                    <h3
                                                        style={{
                                                            color: "white",
                                                            borderBottom: selectedTab === 1 ? "2px solid white" : "none",
                                                            paddingBottom: '5px'
                                                        }}
                                                    >
                                                        NextContent
                                                    </h3>
                                                </Tab>
                                                <Tab>
                                                    <h3
                                                        style={{
                                                            color: "white",
                                                            borderBottom: selectedTab === 2 ? "2px solid white" : "none",
                                                            paddingBottom: '5px'
                                                        }}
                                                    >
                                                        NextCrisis
                                                    </h3>
                                                </Tab>
                                            </TabList>
                                        </div>
                                        <div style={{ border: "1px solid gray", borderRadius: "1em", backgroundColor: 'rgb(253, 253, 253)' }}>
                                            <TabPanel>
                                                <Container style={{ maxWidth: "85em", marginLeft: "6em", narginRight: "4em", marginTop: "2em", marginBottom: "2em" }}>

                                                    <div className="audience-overview" style={{ marginTop: "2em" }}>


                                                        <h3 style={{ marginTop: '2em', marginBottom: '2em' }}>Distribution of Insight Resources</h3>

                                                        <div className="segment-distribution" style={{ maxWidth: "40em", marginLeft: "25em" }}>
                                                            <Pie data={pieData} options={pieOptions} />
                                                        </div>
                                                    </div>


                                                    <hr style={{ margin: '20px 0', borderColor: '#ccc', marginBottom: "2em", marginTop: "2em" }} />

                                                    <div className="audience-segmentation">
                                                        <h3 style={{ marginTop: '2em', marginBottom: '2em' }}>Audience Segmentation & Persona</h3>
                                                        <div className="segment-distribution" style={{ maxWidth: "70%", marginLeft: "15%" }}>
                                                            <Bar data={classificationData} options={barOptions} />
                                                        </div>
                                                        <h3 style={{ marginTop: '2em', marginBottom: '2em' }}>Insights Into Each Segment</h3>

                                                        <div>
                                                            {uniqueSegments.map((segment, index) => (
                                                                <div key={index} style={{ marginTop: "0em", marginBottom: "0em" }}>
                                                                    <div style={columnStyle}>
                                                                        <div style={{ marginTop: "0em", marginBottom: "2em" }}>
                                                                            <strong style={{ fontSize: "1.5em" }}>{segment}</strong>
                                                                            <p>{segmentDescriptions[segment] || "Description not available for this segment."}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>

                                                    </div>
                                                    <h3 style={{ marginTop: '2em', marginBottom: '2em' }}>Download Users of Each Segment</h3>

                                                    <div>
                                                        <div style={rowStyle2}>
                                                            <div style={columnStyle2}>
                                                                <button style={buttonStyle}
                                                                    onClick={() => handleSegmentClick("Price-Sensitive Shopper")}
                                                                >Price-Sensitive Shoppers</button>
                                                            </div>
                                                            <div style={columnStyle2}>
                                                                <button style={buttonStyle2}
                                                                    onClick={() => handleSegmentClick("Brand Loyalist")}
                                                                >Brand Loyalists</button>
                                                            </div>
                                                            <div style={columnStyle2}>
                                                                <button style={buttonStyle2}
                                                                    onClick={() => handleSegmentClick("Impulse Buyer")}
                                                                >Impulse Buyers</button>
                                                            </div>
                                                        </div>
                                                        <div style={rowStyle2}>
                                                            <div style={columnStyle2}>
                                                                <button style={buttonStyle2}
                                                                    onClick={() => handleSegmentClick("Quality Seeker")}
                                                                >Quality Seekers</button>
                                                            </div>
                                                            <div style={columnStyle2}>
                                                                <button style={buttonStyle2}
                                                                    onClick={() => handleSegmentClick("Socially Conscious Consumer")}
                                                                >Socially Conscious Consumers</button>
                                                            </div>
                                                            <div style={columnStyle2}>
                                                                <button style={buttonStyle2}
                                                                    onClick={() => handleSegmentClick("Tech-Savvy Enthusiast")}
                                                                >Tech-Savvy Enthusiast</button>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Textbox to display selected IDs */}
                                                    <div style={{ marginTop: "1em" }}>
                                                        <textarea
                                                            style={{ width: "100%", height: "100px", padding: "10px", boxSizing: "border-box" }}
                                                            readOnly
                                                            value={selectedSegmentIDs.join(", ")}
                                                            placeholder="Selected IDs will appear here..."
                                                        />
                                                    </div>

                                                    <hr style={{ margin: '20px 0', borderColor: '#ccc', marginBottom: "2em", marginTop: "2em" }} />

                                                    <div className="audience-segmentation">
                                                        <h3 style={{ marginTop: '2em', marginBottom: '2em' }}>Audience Clusters Based on CRM Data</h3>
                                                        <div className="segment-distribution" style={{ maxWidth: "70%", marginLeft: "15%" }}>
                                                            <Bar data={clusterData} options={barOptions} />
                                                        </div>
                                                        <h3 style={{ marginTop: '2em', marginBottom: '2em' }}>Insights Into Each Cluster</h3>

                                                        <div>
                                                            {uniqueClusters.map((cluster, index) => (
                                                                <div key={index} style={{ marginTop: "0em", marginBottom: "0em" }}>
                                                                    <div>
                                                                        <div style={{ marginTop: "0em", marginBottom: "2em" }}>
                                                                            <strong style={{ fontSize: "1.5em" }}>{cluster}</strong>
                                                                            <p>{clusterDescriptions[cluster] || "Description not available for this cluster."}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                    <h3 style={{ marginTop: '2em', marginBottom: '2em' }}>Download Users of Each cluster</h3>


                                                    <div style={rowStyle2}>
                                                        <div style={columnStyle2}>
                                                            <button
                                                                style={buttonStyle}
                                                                onClick={() => handleClusterClick("Value-Oriented Shoppers")}
                                                            >
                                                                Value-Oriented Shoppers
                                                            </button>
                                                        </div>
                                                        <div style={columnStyle2}>
                                                            <button
                                                                style={buttonStyle2}
                                                                onClick={() => handleClusterClick("Affluent Brand Loyalists")}
                                                            >
                                                                Affluent Brand Loyalists
                                                            </button>
                                                        </div>
                                                        <div style={columnStyle2}>
                                                            <button
                                                                style={buttonStyle2}
                                                                onClick={() => handleClusterClick("Young Social Media Enthusiasts")}
                                                            >
                                                                Young Social Media Enthusiasts
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div style={rowStyle2}>
                                                        <div style={columnStyle2}>
                                                            <button
                                                                style={buttonStyle2}
                                                                onClick={() => handleClusterClick("Traditional Shoppers")}
                                                            >
                                                                Traditional Shoppers
                                                            </button>
                                                        </div>
                                                        <div style={columnStyle2}>
                                                            <button
                                                                style={buttonStyle2}
                                                                onClick={() => handleClusterClick("Budget-Conscious Buyers")}
                                                            >
                                                                Budget-Conscious Buyers
                                                            </button>
                                                        </div>
                                                    </div>

                                                    {/* Textbox to display selected IDs */}
                                                    <div style={{ marginTop: "1em" }}>
                                                        <textarea
                                                            style={{ width: "100%", height: "100px", padding: "10px", boxSizing: "border-box" }}
                                                            readOnly
                                                            value={selectedIDs.join(", ")}
                                                            placeholder="Selected IDs will appear here..."
                                                        />
                                                    </div>

                                                    <hr style={{ margin: '20px 0', borderColor: '#ccc', marginBottom: "2em", marginTop: "2em" }} />

                                                    <div className="audience-segmentation">
                                                        <h3 style={{ marginTop: '2em', marginBottom: '2em' }}>Website Users Segmentation</h3>
                                                        <div className="segment-distribution" style={{ maxWidth: "70%", marginLeft: "15%" }}>
                                                            <Bar data={webClassificationData} options={barOptions} />
                                                        </div>
                                                        <h3 style={{ marginTop: '2em', marginBottom: '2em' }}>Insights Into Each Segment</h3>

                                                        <div>
                                                            {webUniqueSegments.map((website_segment, index) => (
                                                                <div key={index} style={{ marginTop: "0em", marginBottom: "0em" }}>
                                                                    <div >
                                                                        <div style={{ marginTop: "0em", marginBottom: "2em" }}>
                                                                            <strong style={{ fontSize: "1.5em" }}>{website_segment}</strong>
                                                                            <p>{webSegmentDescriptions[website_segment] || "Description not available for this website_segment."}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                    <h3 style={{ marginTop: '2em', marginBottom: '2em' }}>Download Users of Each Segment</h3>

                                                    <div>
                                                        <div style={rowStyle2}>
                                                            <div style={columnStyle2}>
                                                                <button style={buttonStyle}
                                                                    onClick={() => handleWebSegmentClick("Buyer")}
                                                                >Buyer</button>
                                                            </div>
                                                            <div style={columnStyle2}>
                                                                <button style={buttonStyle2}
                                                                    onClick={() => handleWebSegmentClick("Non-Engaged")}
                                                                >Non-Engaged</button>
                                                            </div>
                                                            <div style={columnStyle2}>
                                                                <button style={buttonStyle2}
                                                                    onClick={() => handleWebSegmentClick("Browser")}
                                                                >Browser</button>
                                                            </div>
                                                        </div>

                                                    </div>

                                                    {/* Textbox to display selected IDs */}
                                                    <div style={{ marginTop: "1em" }}>
                                                        <textarea
                                                            style={{ width: "100%", height: "100px", padding: "10px", boxSizing: "border-box" }}
                                                            readOnly
                                                            value={selectedWebSegmentIDs.join(", ")}
                                                            placeholder="Selected IDs will appear here..."
                                                        />
                                                    </div>


                                                    <hr style={{ margin: '20px 0', borderColor: '#ccc', marginBottom: "2em", marginTop: "2em" }} />

                                                    <div className="audience-segmentation">
                                                        <h3 style={{ marginTop: '2em', marginBottom: '2em' }}>Web Users Clusters</h3>
                                                        <div className="segment-distribution" style={{ maxWidth: "70%", marginLeft: "15%" }}>
                                                            <Bar data={webClusterData} options={barOptions} />
                                                        </div>
                                                        <h3 style={{ marginTop: '2em', marginBottom: '2em' }}>Insights Into Each Cluster</h3>

                                                        <div>
                                                            {uniqueWebClusters.map((website_cluster, index) => (
                                                                <div key={index} style={{ marginTop: "0em", marginBottom: "0em" }}>
                                                                    <div >
                                                                        <div style={{ marginTop: "0em", marginBottom: "2em" }}>
                                                                            <strong style={{ fontSize: "1.5em" }}>{website_cluster}</strong>
                                                                            <p>{webClusterDescriptions[website_cluster] || "Description not available for this website_cluster."}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                    <h3 style={{ marginTop: '2em', marginBottom: '2em' }}>Download Users of Each Web cluster</h3>

                                                    <div>
                                                        <div style={rowStyle2}>
                                                            <div style={columnStyle2}>
                                                                <button style={buttonStyle}
                                                                    onClick={() => handleWebClusterClick("Engaged Buyers")}
                                                                >Engaged Buyers</button>
                                                            </div>
                                                            <div style={columnStyle2}>
                                                                <button style={buttonStyle2}
                                                                    onClick={() => handleWebClusterClick("Casual Browsers")}
                                                                >Casual Browsers</button>
                                                            </div>
                                                            <div style={columnStyle2}>
                                                                <button style={buttonStyle2}
                                                                    onClick={() => handleWebClusterClick("Bouncers")}
                                                                >Bouncers</button>
                                                            </div>
                                                        </div>
                                                        <div style={rowStyle2}>
                                                            <div style={columnStyle2}>
                                                                <button style={buttonStyle2}
                                                                    onClick={() => handleWebClusterClick("Decisive Shoppers")}
                                                                >Decisive Shoppers</button>
                                                            </div>

                                                            <div style={columnStyle2}>
                                                                <button style={buttonStyle2}
                                                                    onClick={() => handleWebClusterClick("Indecisive Explorers")}
                                                                >Indecisive Explorers</button>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Textbox to display selected IDs */}
                                                    <div style={{ marginTop: "1em" }}>
                                                        <textarea
                                                            style={{ width: "100%", height: "100px", padding: "10px", boxSizing: "border-box" }}
                                                            readOnly
                                                            value={selectedWebClusterIDs.join(", ")}
                                                            placeholder="Selected IDs will appear here..."
                                                        />
                                                    </div>

                                                    <hr style={{ margin: '20px 0', borderColor: '#ccc', marginBottom: "2em", marginTop: "2em" }} />
                                                    {/* Sample Table for User Details */}
                                                    {/*
                                                    <div>
                                                        <h3>User Details</h3>
                                                        <Table striped bordered hover>
                                                            <thead>
                                                                <tr>
                                                                    <th>Name</th>
                                                                    <th>Satisfaction</th>
                                                                    <th>Purchase Probability</th>
                                                                    <th>Status</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>User A</td>
                                                                    <td>High</td>
                                                                    <td>90%</td>
                                                                    <td>Promoter</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>User B</td>
                                                                    <td>Medium</td>
                                                                    <td>60%</td>
                                                                    <td>Neutral</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>User C</td>
                                                                    <td>Low</td>
                                                                    <td>30%</td>
                                                                    <td>Detractor</td>
                                                                </tr>
                                                            </tbody>
                                                        </Table>
                                                    </div>
*/}

                                                </Container>
                                            </TabPanel>

                                            <TabPanel>
                                                {/* Content for NextContent */}
                                                <Container style={{ maxWidth: "85em", marginLeft: "6em", narginRight: "4em", marginTop: "2em", marginBottom: "2em" }}>
                                                    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
                                                        {/* Content Needs by Segment */}
                                                        <div style={{ marginBottom: '2em' }}>
                                                            <h3 style={{ marginBottom: '2em' }}>Content Needs by Segment</h3>
                                                            <Radar data={contentNeedsData} />
                                                        </div>
                                                        <hr style={{ margin: '20px 0', borderColor: '#ccc', marginBottom: "2em", marginTop: "2em" }} />

                                                        {/* Content Generation Interface for Segments */}
                                                        <div style={{ marginBottom: "2em" }}>
                                                            <h3 style={{ marginBottom: "2em" }}>Generate Content for Segments</h3>
                                                            <Form>
                                                                <Form.Group controlId="formCompanyName" style={{ maxWidth: "60em", marginBottom: "2em" }}>
                                                                    <Form.Label style={{ fontSize: "1.5em" }}>Company Name</Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        placeholder="Enter Company Name"
                                                                        value={companyName}
                                                                        onChange={(e) => setCompanyName(e.target.value)}
                                                                    />
                                                                </Form.Group>

                                                                <Form.Group controlId="formProductDescription" style={{ maxWidth: "60em", marginBottom: "2em" }}>
                                                                    <Form.Label style={{ fontSize: "1.5em" }}>Product Name & Description</Form.Label>
                                                                    <Form.Control
                                                                        as="textarea"
                                                                        rows={3}
                                                                        placeholder="Enter Product Name and Description"
                                                                        value={productDescription}
                                                                        onChange={(e) => setProductDescription(e.target.value)}
                                                                    />
                                                                </Form.Group>

                                                                <div style={{ display: "flex", justifyContent: "space-between", gap: "2em", alignItems: "flex-start", marginTop:"1em" }}>
                                                                    <Form.Group controlId="formMedia" style={{ marginBottom: "2em", flex: 1 }}>
                                                                        <Form.Label style={{ fontSize: "1.5em" }}>Select Media</Form.Label>
                                                                        <DropdownButton
                                                                            style={{ maxWidth: "100%" }}
                                                                            variant="secondary"
                                                                            title={selectedMedia}
                                                                            onSelect={(e) => setSelectedMedia(e)}
                                                                        >
                                                                            <Dropdown.Item eventKey="Email">Email</Dropdown.Item>
                                                                            <Dropdown.Item eventKey="SMS">SMS</Dropdown.Item>
                                                                            <Dropdown.Item eventKey="Instagram Post">Instagram Post</Dropdown.Item>
                                                                            <Dropdown.Item eventKey="Instagram Story">Instagram Story</Dropdown.Item>
                                                                            <Dropdown.Item eventKey="LinkedIn Post">LinkedIn Post</Dropdown.Item>
                                                                            <Dropdown.Item eventKey="X (Twitter) Post">X (Twitter) Post</Dropdown.Item>
                                                                            <Dropdown.Item eventKey="Facebook Post">Facebook Post</Dropdown.Item>
                                                                            <Dropdown.Item eventKey="WhatsApp-Telegram Post">WhatsApp/Telegram Post</Dropdown.Item>
                                                                        </DropdownButton>
                                                                    </Form.Group>

                                                                    <Form.Group controlId="formPersona" style={{ marginBottom: "2em", flex: 1 }}>
                                                                        <Form.Label style={{ fontSize: "1.5em" }}>Select Audience Persona</Form.Label>
                                                                        <DropdownButton
                                                                            style={{ maxWidth: "100%" }}
                                                                            variant="secondary"
                                                                            title={selectedPersona}
                                                                            onSelect={(e) => setSelectedPersona(e)}
                                                                        >
                                                                            <Dropdown.Item eventKey="Brand Loyalist">Brand Loyalist</Dropdown.Item>
                                                                            <Dropdown.Item eventKey="Price-Sensitive Shopper">Price-Sensitive Shopper</Dropdown.Item>
                                                                            <Dropdown.Item eventKey="Impulse Buyer">Impulse Buyer</Dropdown.Item>
                                                                            <Dropdown.Item eventKey="Quality Seeker">Quality Seeker</Dropdown.Item>
                                                                            <Dropdown.Item eventKey="Socially Conscious Consumer">Socially Conscious Consumer</Dropdown.Item>
                                                                            <Dropdown.Item eventKey="Tech-Savvy Enthusiast">Tech-Savvy Enthusiast</Dropdown.Item>
                                                                        </DropdownButton>
                                                                    </Form.Group>
                                                                </div>

                                                                <Form.Group controlId="formSubject" style={{ maxWidth: "60em", marginBottom: "2em" }}>
                                                                    <Form.Label style={{ fontSize: "1.5em" }}>Subject</Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        placeholder="Enter Subject"
                                                                        value={subject}
                                                                        onChange={(e) => setSubject(e.target.value)}
                                                                    />
                                                                </Form.Group>

                                                                <Button
                                                                    variant="primary"
                                                                    onClick={generateContent}
                                                                    style={{
                                                                        width: "12em", // Set the width of the button
                                                                        height: "3em", // Set the height of the button
                                                                        padding: "0.05 0.5em", // Adjust padding if needed
                                                                        fontSize: "1.5em", // Adjust font size for larger text
                                                                    }}
                                                                >
                                                                    Generate Content
                                                                </Button>
                                                            </Form>

                                                            <div style={{ marginTop: "1em", position: "relative" }}>
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        alignItems: "center",
                                                                        marginBottom: "0.5em",
                                                                    }}
                                                                >
                                                                    <textarea
                                                                        style={{
                                                                            width: "100%",
                                                                            height: "150px",
                                                                            padding: "10px",
                                                                            boxSizing: "border-box",
                                                                        }}
                                                                        readOnly
                                                                        value={generatedContent}
                                                                        placeholder="Generated Content ..."
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>


                                                        <hr style={{ margin: '20px 0', borderColor: '#ccc', marginBottom: "2em", marginTop: "2em" }} />

                                                        {/* Personalized Message Generation for Individual Users */}
                                                        <div>
                                                            <h3 style={{ marginBottom: "2em" }}>Generate Personalized Messages for Users</h3>

                                                            {/* Textbox to display selected IDs */}
                                                            <div style={columnStyle2}>
                                                                <button
                                                                    style={{
                                                                        width: "12em", // Set the width of the button
                                                                        height: "3em", // Set the height of the button
                                                                        padding: "0 0.5em", // Adjust padding if needed
                                                                        fontSize: "1.5em", // Adjust font size for larger text
                                                                    }} onClick={() => handleNegativeClick()}
                                                                >
                                                                    Who needs care?
                                                                </button>
                                                            </div>
                                                            <div style={{ marginTop: "1em" }}>
                                                                <textarea
                                                                    style={{ width: "100%", height: "100px", padding: "10px", boxSizing: "border-box", marginBottom: "2em" }}
                                                                    readOnly
                                                                    value={selectedNegativeIDs.join(", ")}
                                                                    placeholder="They need care ..."
                                                                />
                                                            </div>


                                                            <Form>
                                                                <Form.Group controlId="formCompanyName" style={{ maxWidth: "60em", marginBottom: "2em" }}>
                                                                    <Form.Label style={{ fontSize: "1.5em" }}>Company Name</Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        placeholder="Enter Company Name"
                                                                        value={companyName}
                                                                        onChange={(e) => setCompanyName(e.target.value)}
                                                                    />
                                                                </Form.Group>

                                                                <Form.Group controlId="formProductDescription" style={{ maxWidth: "60em", marginBottom: "2em" }}>
                                                                    <Form.Label style={{ fontSize: "1.5em" }}>Product Name & Description</Form.Label>
                                                                    <Form.Control
                                                                        as="textarea"
                                                                        rows={3}
                                                                        placeholder="Enter Product Name and Description"
                                                                        value={productDescription}
                                                                        onChange={(e) => setProductDescription(e.target.value)}
                                                                    />
                                                                </Form.Group>
                                                                <Form.Group controlId="formMedia">
                                                                    <Form.Label style={{ fontSize: "1.5em" }}>Select Media</Form.Label>
                                                                    <DropdownButton
                                                                        style={{ maxWidth: "25em" }}
                                                                        variant="secondary"
                                                                        title={selectedPersonalizedMedia}
                                                                        onSelect={(e) => setSelectedPersonalizedMedia(e)}
                                                                    >
                                                                        <Dropdown.Item eventKey="Email" >Email</Dropdown.Item>
                                                                        <Dropdown.Item eventKey="SMS">SMS</Dropdown.Item>
                                                                        <Dropdown.Item eventKey="Whatapp-Telegram Message">Whatapp-Telegram Message</Dropdown.Item>
                                                                    </DropdownButton>
                                                                </Form.Group>
                                                                <div style={{ display: 'flex', gap: '2em', flexWrap: 'wrap', marginTop: '2em' }}>
                                                                    <Form.Group controlId="formSubject" style={{ flex: '1', minWidth: '300px' }}>
                                                                        <Form.Label style={{ fontSize: "1.5em" }}>Subject</Form.Label>
                                                                        <Form.Control
                                                                            type="text"
                                                                            placeholder="Enter Subject"
                                                                            value={personalizedSubject}
                                                                            onChange={(e) => setPersonalizedSubject(e.target.value)}
                                                                        />
                                                                    </Form.Group>


                                                                </div>

                                                            </Form>
                                                            <div>
                                                                <button
                                                                    style={{
                                                                        width: "20em",  // Set the width of the button
                                                                        height: "3em",  // Set the height of the button
                                                                        padding: "0.0 0.5em",  // Adjust padding if needed
                                                                        fontSize: "1.5em",  // Adjust font size for larger text
                                                                        marginTop: "1em",
                                                                        marginBottom: "2em",
                                                                    }}
                                                                    onClick={generateContentForItems}>Generate Personalized Content</button>

                                                                {data
                                                                    .filter(
                                                                        (item) =>
                                                                            (item.cussup_sentiment === "negative" || item.social_sentiment === "negative") &&
                                                                            item.email === storedEmail
                                                                    )
                                                                    .map((item) => (
                                                                        <div key={item.id} style={{ marginTop: "1em", position: "relative" }}>
                                                                            <div
                                                                                style={{
                                                                                    display: "flex",
                                                                                    justifyContent: "space-between",
                                                                                    alignItems: "center",
                                                                                    marginBottom: "0.5em",
                                                                                }}
                                                                            >
                                                                                <textarea
                                                                                    style={{
                                                                                        width: "100%",
                                                                                        height: "6em",
                                                                                        padding: "1em",
                                                                                        boxSizing: "border-box",
                                                                                    }}
                                                                                    readOnly
                                                                                    value={generatedContents[item.id]}
                                                                                    placeholder="Generated Content ..."
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Container>
                                            </TabPanel>

                                            <TabPanel>

                                                {/* Content for NextCrisis */}
                                                <Container style={{ maxWidth: "85em", marginLeft: "6em", narginRight: "4em", marginTop: "2em", marginBottom: "2em" }}>
                                                    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
                                                        {/* Social Media Sentiments */}
                                                        <div style={{ marginBottom: '0em' }}>
                                                            <h3>Sentiments Map</h3>
                                                            <Radar data={socialSentimentData} />
                                                        </div>
                                                        <hr style={{ margin: '20px 0', borderColor: '#ccc', marginBottom: "2em", marginTop: "2em" }} />


                                                        <div className="crisis-management-section">
                                                            <h3 style={{ marginBottom: "1em" }}>Crisis Management in Social Media</h3>
                                                            {socialCrisisData.length > 0 ? (
                                                                socialCrisisData.map((item, index) => (
                                                                    <div key={index} className="crisis-card" style={{ marginBottom: "1em", border: "1px solid #ddd", borderRadius: "8px", padding: "1em" }}>
                                                                        <div style={{ backgroundColor: "#ffe6e6", padding: "0.5em", borderRadius: "8px", marginBottom: "0.5em" }}>
                                                                            <h4>Explanation</h4>
                                                                            <p>{item.social_crisis_explanation}</p>
                                                                        </div>
                                                                        <div style={{ backgroundColor: "#e6f7ff", padding: "0.5em", borderRadius: "8px" }}>
                                                                            <h4>Solution</h4>
                                                                            <p>{item.social_crisis_solution}</p>
                                                                        </div>
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <p>No critical issues found in Social Media.</p>
                                                            )}
                                                        </div>
                                                        <hr style={{ margin: '20px 0', borderColor: '#ccc', marginBottom: "2em", marginTop: "2em" }} />

                                                        <div className="crisis-management-section">
                                                            <h3 style={{ marginBottom: "1em" }}>Crisis Management in Customer Support</h3>
                                                            {cussupCrisisData.length > 0 ? (
                                                                cussupCrisisData.map((item, index) => (
                                                                    <div key={index} className="crisis-card" style={{ marginBottom: "1em", border: "1px solid #ddd", borderRadius: "8px", padding: "1em" }}>
                                                                        <div style={{ backgroundColor: "#fff3e6", padding: "0.5em", borderRadius: "8px", marginBottom: "0.5em" }}>
                                                                            <h4>Explanation</h4>
                                                                            <p>{item.cussup_crisis_explanation}</p>
                                                                        </div>
                                                                        <div style={{ backgroundColor: "#e6ffe6", padding: "0.5em", borderRadius: "8px" }}>
                                                                            <h4>Solution</h4>
                                                                            <p>{item.cussup_crisis_solution}</p>
                                                                        </div>
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <p>No critical issues found in Customer Support.</p>
                                                            )}
                                                        </div>


                                                    </div>
                                                </Container>
                                            </TabPanel>
                                        </div>
                                    </Tabs>
                                </div>
                            </div>
                            {/* Card Modal and Side Bar Components */}
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default Profile1;
